import bsGetCid from '../BsGetCid';
import Env from "../BsGetEnv";
import bsUtil from '../BsUtil';
import click from './click'
import mutation from './mutation'
import BsUtil from '../BsUtil';
import BsStatReport from '../BsStatReport';
import show from './show'


function Tracking(config = {}, data, plugin = []){
    if(!config.name){
        console.error('埋点：初始化name必填！')
        return;
    }
    const sys = Env.isAndroid ? 'andriod' : (Env.isiPhone ? 'ios' : 'other')
    this.defaultData = {
        // currentEnv: await bsUtil.currentEnv || 'h5',
        sys: sys, // 默认参数增加设备类型 andriod,ios
        orderPosition: BsUtil.queryString('ad_location') || ''
    };
    config.cid = config.cid
     // 初始化点击事件
    click(this.autoParams.bind(this));
    show(this.autoParams.bind(this))
    this.addplugin(plugin);
    this.addCommonParams(data)
    this.stat = new BsStatReport(config)
}
Tracking.prototype.addplugin = function(arg){
    for(var i = 0 ; i < arg.length; i++){
        if(arg[i].name === 'WaitTime'){
            this.waitTime = arg[i]
            this.waitTime.init(this.report.bind(this))
        }else if(arg[i].name === 'exp'){
             // 初始化页面曝光
            this.exp = arg[i]
            this.exp.init(this.autoParams.bind(this));
        }
        // 监控DOM元素变化
        mutation(this.autoParams.bind(this), this.exp);
    }
}
// 初始化页面参数
Tracking.prototype.addCommonParams = function(data){
    try {
        // 设置默认数据
        if(bsUtil.isObject(data)){
            if(data.waitTimeName && this.waitTime){
                this.waitTime.getWaitTimeName(data.waitTimeName, data);
                delete data.waitTimeName;
            }
            this.defaultData = {...this.defaultData, ...data}
        } else {
            console.error('埋点：初始化参数必须是对象！')
        }
    } catch (error) {
        console.log(error);
    }
}
Tracking.prototype.report = async function(code, data = {}, cb){
    if(!this.stat){
        console.log('埋点上报前必须先初始化！')
        return
    }
    if(!data.cid && !this.cid){
        data.cid = (await bsGetCid()).cid
    }
    data.cid = data.cid || this.cid
    this.defaultData.currentEnv = this.defaultData.currentEnv || await bsUtil.currentEnv || 'h5'
    this.stat.send(code, {...this.defaultData, ...data}, cb)
}
// 业务调用参数
Tracking.prototype.addStat = function(code, data, cb){
    try {
        this.report(code, data, cb)
    } catch (error) {
        console.log(error);
    }
}

// 自动上报埋点参数处理
Tracking.prototype.autoParams = function(str){
    try {
        if(bsUtil.isString(str)){
            let query = bsUtil.getQuery(str);
            let redirectUrl;
            if(query.redirectUrl){
                redirectUrl = query.redirectUrl;
                delete query.redirectUrl;
            }
            if(query.code) {
                let code = query.code;
                delete query.code
                this.report(code, query,  ()=>{
                    redirectUrl && (location.href = redirectUrl)
                })
            } else {
                console.log('埋点名必传！')
            }
        }
    } catch (error) {
        console.log(error);
    }
} 

export default Tracking